import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import { is3dMode } from "../../../configs/is_3d_mode";

@Component({
  selector: 'app-camera-rotate-three-d',
  templateUrl: './camera-rotate-three-d.component.html',
  styleUrls: ['./camera-rotate-three-d.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CameraRotateThreeDComponent implements OnInit {

  public isEnabled;

  public isMode3d;

  constructor(protected adapter: CesiumAdapterService, protected cd: ChangeDetectorRef) { }

  ngOnInit() {

    this.isMode3d = is3dMode;

    if (!this.isMode3d){
      this.adapter.toggleThreeDMode();
    }

    this.adapter.isThreeDModeEnabled.subscribe((val)=>{
        this.cd.markForCheck();
        this.isEnabled = val;
      this.cd.detectChanges();
    })
  }

  toggleThreeDMode(){
    if(this.isMode3d){
      this.adapter.toggleThreeDMode();
    }
  }
}
